export var MAX_MODAL_SIZE = '100%';
export var MIN_MODAL_SIZE = 'large';